import { NgZone, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { JwtAuthService } from 'src/services/jwt-auth.service';

const publicRoute = ['/login'];

export const loginGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(JwtAuthService);
  const ngZone = inject(NgZone);
  const isLoggedIn = auth.isLoggedin();

  if (isLoggedIn) {
    if (publicRoute.includes(state.url)) {
      ngZone.run(() => {
        router.navigate(['/']);
      });
    }
    return true;
  } else {
    const url = state.url.split('?')[0];
    if (url && publicRoute.includes(url)) {
      return true;
    } else {
      ngZone.run(() => {
        router.navigate(['/login']);
      });
    }
    return false;
  }
};
